"use client";

import { Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { getMarketingChrome } from "~/lib/siteglue/marketing-chrome";

const SplashScreen = () => {
  const [isClient, setIsClient] = useState(false);
  const [shouldShowContent, setShouldShowContent] = useState(false);
  const [chrome, setChrome] = useState(() => getMarketingChrome("www.easygpt.builders"));

  useEffect(() => {
    setIsClient(true);
    const isInIframe = window.self !== window.top;
    setShouldShowContent(!isInIframe);
    setChrome(getMarketingChrome(window.location.hostname));
  }, []);

  const isSiteGlue = chrome.brandId === "siteglue";

  return (
    <div className="-mt-5 flex h-screen flex-col items-center justify-center gap-8">
      {isClient && shouldShowContent && (
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tight">
            {isSiteGlue ? (
              <>
                <span style={{ color: chrome.primaryColor }}>Site</span>
                <span style={{ color: chrome.accentColor }}>Glue</span>
                <span className="text-slate-800"> AI</span>
              </>
            ) : (
              chrome.productName
            )}
          </h1>
          <h2 className="mt-2 text-wrap text-xl text-muted-foreground">
            {isSiteGlue
              ? "Build, train and deploy human in the loop agents in minutes"
              : "Build, train and deploy an AI Agent in minutes"}
          </h2>
        </div>
      )}
      <Loader2
        className="h-8 w-8 animate-spin"
        style={isSiteGlue ? { color: chrome.primaryColor } : undefined}
      />
    </div>
  );
};

export default SplashScreen;
